import React from 'react';

const Logo = ({ width = "180px", height = "auto", className = "", lightText = false }) => {
    return (
        <div className={`logo-wrapper ${className}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400" width={width} height={height}>
                {/* ================= MODERN İKON ================= */}
                <g>
                    {/* 1. Kesintisiz, Tok 'S' Yolu (Koyu Kayrak / Deep Slate) */}
                    <path d="M 270 150 L 240 150 A 30 30 0 0 0 240 210 L 270 210 A 30 30 0 0 1 270 270 L 240 270"
                        fill="none" stroke={lightText ? "#FFFFFF" : "#1E293B"} strokeWidth="20" strokeLinecap="round" />

                    {/* 2. "Live" / "Top" Noktası (Zümrüt Yeşili) */}
                    <circle cx="240" cy="180" r="9" fill="#10B981" />

                    {/* 3. Denge / Sistem Noktası (Açık Kayrak Gri) */}
                    <circle cx="270" cy="240" r="9" fill="#94A3B8" />
                </g>

                {/* ================= TİPOGRAFİ ================= */}

                {/* 1. Ana Marka Adı (Kalın-İnce Kontrastı) */}
                <text x="340" y="235" fontFamily="'Outfit', sans-serif" fontSize="76" letterSpacing="-1">
                    <tspan fontWeight="800" fill={lightText ? "#FFFFFF" : "#1E293B"}>saha</tspan><tspan fontWeight="300" fill="#10B981">live</tspan>
                </text>

                {/* 2. Kurumsal Alt Başlık */}
                <text x="345" y="265" fontFamily="'Outfit', sans-serif" fontWeight="500" fontSize="13" letterSpacing="4.5" fill={lightText ? "#94A3B8" : "#64748B"}>
                    DİJİTAL HALI SAHA SİSTEMİ
                </text>
            </svg>
        </div>
    );
};

export default Logo;
